<template>
    <div class="test-item-wrapper">
        <div>
            <div class="title">{{test.title}}</div>
            <div class="date">
                Время прохождения
                <span class="">{{test.timing}}</span>
            </div>
            <div class="result">
                <div
                    v-if="test.is_active === 1"
                    class="result__completed"
                />
            </div>
        </div>
        <div class="actions">
            <div
                v-if="test.is_active === 1"
                class="actions__item actions__item--blue"
            >
                <a
                    rel="noopener noreferrer"
                    target="_blank"
                    @click.prevent='isPopup = true'
                >Посмотреть результаты</a>
            </div>
        </div>
        <Dialog v-model='isPopup'>
            <ProjectoryTest
                class='projectoryTest'
                :projectoryTestId='test.id'
            />
        </Dialog>
    </div>
</template>

<script>
import Dialog from '../../../UI/Dialog';
import ProjectoryTest from '../../../../views/ProektoriaTest';

export default {
    name: 'ProjectoryTestCompletedItem',
    props: {
        test: Object,
    },
    data: () => ({
        isPopup: false,
    }),
    components: {
        Dialog,
        ProjectoryTest,
    },
};
</script>

<style scoped lang="scss">
    @import '../../../../styles/rem';

    .test-item-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-height: rem(202);
        width: 49%;
        background-color: #fff;
        padding: rem(24);
        margin-bottom: rem(18);
        box-shadow: 0 rem(6) rem(10) rgba(131, 134, 163, 0.12);

        .projectoryTest {
            max-width: rem(772);
        }

        @include on-mobile {
            width: 100%;
            height: auto;
            padding: mrem(24);
            margin: 0 mrem(16) mrem(12);

            .projectoryTest {
                max-width: 90rem;
            }
        }

        .title {
            font-family: "Montserrat", sans-serif;
            font-style: normal;
            font-weight: 600;
            font-size: rem(16);
            line-height: rem(24);
            color: #2A2626;
            padding-bottom: rem(16);

            @include on-mobile {
                font-size: mrem(15);
                line-height: mrem(22);
                padding-bottom: mrem(16);
            }
        }

        .date,
        .result {
            font-family: "Montserrat", sans-serif;
            font-style: normal;
            font-weight: normal;
            font-size: rem(14);
            line-height: rem(20);
            color: #2A2626;
            padding-bottom: rem(8);

            &--bold {
                font-weight: bold;
            }

            &__check {
                font-weight: 600;
                color: #EF627D;
            }

            @include on-mobile {
                font-size: mrem(14);
                line-height: mrem(20);
                padding-bottom: mrem(8);
            }
        }

        .actions {
            display: flex;
            justify-content: flex-end;
            margin-top: rem(12);

            @include on-mobile {
                flex-direction: column;
            }

            &__item {

                @include on-mobile {
                    margin-top: mrem(16);
                }

                a {
                    cursor: pointer;
                    display: inline;
                    font-family: "Montserrat", sans-serif;
                    font-style: normal;
                    font-weight: 500;
                    font-size: rem(14);
                    line-height: rem(17);
                    text-align: center;
                    padding-bottom: rem(4);
                    color: #97A4BA;
                    border-bottom: 1px solid #97A4BA;

                    @include on-mobile {
                        font-size: 14px;
                        line-height: 17px;
                        display: inline;
                    }
                }

                &--blue a {
                    color: #4663AB;
                    border-bottom: 1px solid #4663AB;
                }
            }
        }
    }
</style>
